import { useAudience, AUDIENCES } from "@/contexts/AudienceContext";
import { X, Users } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function AudienceSelector() {
  const { audience, selectAudience, showSelector, setShowSelector } = useAudience();

  if (!showSelector) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-foreground/40" data-testid="audience-modal">
      <div className="bg-card rounded-2xl shadow-2xl max-w-md w-full p-6 sm:p-8 relative border">
        <button
          onClick={() => { setShowSelector(false); if (!audience) selectAudience('patient'); }}
          className="absolute top-4 right-4 text-muted-foreground hover:text-foreground"
          data-testid="audience-close"
        >
          <X className="w-5 h-5" />
        </button>

        <div className="text-center mb-6">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-accent/10 mb-3">
            <Users className="w-6 h-6 text-accent" />
          </div>
          <h2 className="font-heading text-xl sm:text-2xl font-semibold">Who are you browsing as?</h2>
          <p className="text-sm text-muted-foreground mt-2">
            We'll tailor the content depth to your needs
          </p>
        </div>

        <div className="space-y-3">
          {AUDIENCES.map((a) => (
            <button
              key={a.id}
              data-testid={`audience-${a.id}`}
              onClick={() => selectAudience(a.id)}
              className={`w-full text-left p-4 rounded-xl border-2 transition-all hover:-translate-y-0.5 hover:shadow-md ${
                audience === a.id
                  ? "border-primary bg-primary/5"
                  : "border-border hover:border-primary/40"
              }`}
            >
              <div className="flex items-center gap-3">
                <span className="text-2xl">{a.icon}</span>
                <div>
                  <h3 className="font-heading font-semibold text-sm">{a.label}</h3>
                  <p className="text-xs text-muted-foreground">{a.desc}</p>
                </div>
              </div>
            </button>
          ))}
        </div>

        <p className="text-xs text-muted-foreground text-center mt-4">
          You can change this anytime from medicine/condition pages
        </p>
      </div>
    </div>
  );
}
